import SectionHeading from '@/pages/home/components/SectionHeading';

const offerings = [
  {
    icon: 'ri-booklet-line',
    title: '剧情脉络速读',
    desc: '把非线性回闪的时间线理顺成一条清楚的主线，先看这里，再追剧就不容易迷路。',
  },
  {
    icon: 'ri-team-line',
    title: '角色关系网',
    desc: '六位核心角色的立场、动机与彼此牵扯一次讲清，谁跟谁有过往，不用自己猜。',
  },
  {
    icon: 'ri-list-check-2',
    title: '八集看点速览',
    desc: '分集拆解每一集的信息重点与埋线手法，适合边看边对照，也方便回看找细节。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '正版观看指引',
    desc: '只说清楚去哪里合法地看，不提供任何未经授权的下载或播放入口，看得安心。',
  },
];

export default function OverviewSection() {
  return (
    <section id="overview" className="border-t border-background-200 bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="站点概览"
          title="这一页能帮你解决什么"
          desc="比起把零散的链接堆在一起，我们更想让你先把这部剧看懂。下面四块内容，构成了这份观剧参考的骨架。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-14 md:gap-6">
          {offerings.map((item) => (
            <article
              key={item.title}
              className="reveal group rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-7"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-7 text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>

        <div className="reveal mt-8 flex flex-col gap-4 rounded-lg border border-accent-300/50 bg-accent-50 p-5 md:mt-12 md:flex-row md:items-center md:justify-between md:p-7">
          <div className="flex items-start gap-3">
            <i className="ri-information-line mt-0.5 text-xl text-accent-800" aria-hidden="true"></i>
            <p className="text-sm leading-7 text-accent-900 md:text-base">
              这里是一份内容向的观剧参考，不是资源下载站。本页不提供任何网盘、种子或在线播放链接。
            </p>
          </div>
          <a
            href="#faq"
            className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-accent-400 bg-background-50 px-5 py-2.5 text-sm font-medium text-accent-900 transition-colors hover:bg-accent-100"
          >
            了解详情
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}